import {useMutation} from "@tanstack/react-query";
import {addExpedientResponsibleMutationOptions} from "./add-expedient-responsible.mutation-options";

export function useAddExpedientResponsible(id: string) {
  return useMutation(addExpedientResponsibleMutationOptions(id));
}
